import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_21: FaireProductEntity = {
  token: "atc_fs_21",
  type: "product",
  name: "Shine Bright Soy Candle",
  brandName: "Be Light Candle Re",
  brandToken: "be-light-candle-re",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8559b426957b1d3db4507700897597c7f509890010a3fbb193970f2af742217a.webp",
  priceDollars: 20,
  msrpDollars: 40,
  description: "ATC migration seed product",
  tags: ["home", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
